import React from "react";

export default function Addproperty() {
  const styles = {
    wrapper: {
      minHeight: "100vh",
      background: "#f4f6f8",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
    },
    card: {
      width: "100%",
      maxWidth: "480px",
      background: "#ffffff",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      overflow: "hidden",
    },
    title: {
      background: "#4f86a3",
      color: "#fff",
      padding: "14px",
      textAlign: "center",
      fontSize: "18px",
      fontWeight: "600",
    },
    body: {
      padding: "16px",
    },
    required: {
      color: "red",
    },
    disabledInput: {
      backgroundColor: "#e9ecef",
    },
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.title}>नोंदणी फॉर्म</div>

        <form style={styles.body}>
          {/* PERSONAL INFO */}
          <div className="card mb-3 shadow-sm">
            <div className="card-body">
              <h6 className="card-title text-primary fw-bold mb-3 text-center border-bottom pb-2">

                व्यक्तिगत माहिती
              </h6>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  नाव <span style={styles.required}>*</span>
                </label>
                <input
                  type="text"
                  className=" flex-fill ml-2 p-2  rounded-xl   form-control border border-1 border-primary shadow-sm"
                />
              </div>

              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="mayat"
                />
                <label className="form-check-label" htmlFor="mayat">
                  मयत
                </label>
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">पत्नीचे नाव</label>
                <input
                  type="text"
                  className=" flex-fill ml-2 p-2  rounded-xl   form-control border border-1 border-primary shadow-sm"
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">मोबाईल नंबर</label>
                <input
                  type="text"
                  className=" flex-fill ml-2 p-2  rounded-xl   form-control border border-1 border-primary shadow-sm"
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  वारसदाराचे नाव
                </label>
                <input
                  type="text"
                  className=" flex-fill ml-2 p-2  rounded-xl   form-control border border-1 border-primary shadow-sm"
                  style={styles.disabledInput}
                  disabled
                />
              </div>
            </div>
          </div>

          {/* IDENTITY INFO */}
          <div className="card mb-3 shadow-sm">
            <div className="card-body">
              <h6 className="card-title text-primary fw-bold mb-3">
                ओळख माहिती
              </h6>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  आधार कार्ड क्रमांक
                </label>
                <input
                  type="text"
                  className=" flex-fill ml-2 p-2  rounded-xl   form-control border border-1 border-primary shadow-sm"
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  पॅन कार्ड क्रमांक
                </label>
                <input
                  type="text"
                  className=" flex-fill ml-2 p-2  rounded-xl   form-control border border-1 border-primary shadow-sm"
                />
              </div>
            </div>
          </div>

          {/* ADDRESS INFO */}
          <div className="card mb-3 shadow-sm">
            <div className="card-body">
              <h6 className="card-title text-primary fw-bold mb-3 ">
                पत्ता माहिती
              </h6>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  वॉर्डचे नाव / क्र
                </label>
                <input
                  type="text"
                  className=" flex-fill ml-2 p-2  rounded-xl   form-control border border-1 border-primary shadow-sm"
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  रोड / गल्ली क्र
                </label>
                <input
                  type="text"
                  className=" flex-fill ml-2 p-2  rounded-xl   form-control border border-1 border-primary shadow-sm"
                />
              </div>
            </div>
          </div>

          {/* BUTTONS */}
            <div className="card shadow-sm">
              <div className="card-body   ">
                <div className="d-flex gap-3">
                  <button
                    type="submit"
    className="btn btn-success flex-fill m-3 px-2 py-2 rounded-full bg-blue-600"
                  >
                    जतन करा
                  </button>

                
                </div>
              </div>
            </div>
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="d-flex gap-3">
             

                <button
                  type="button"
                  className="btn btn-info text-dark flex-fill  bg-green-500 border m-2 p-2  rounded-full"
                >
                  नावाची यादी
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
